import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { http, unwrapApiResponse } from '../api/http';
import {
  clearAdminProfile,
  clearToken,
  getAdminProfile,
  getToken,
  setAdminProfile,
  setToken,
} from './authStorage';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setTokenState] = useState(() => getToken());
  const [admin, setAdminState] = useState(() => getAdminProfile());

  const login = useCallback(async ({ username, password }) => {
    const res = await http.post('/admin/login', { username, password });
    const data = unwrapApiResponse(res);
    const nextToken = data?.token || '';
    if (!nextToken) {
      throw new Error('Token is missing in response');
    }
    setToken(nextToken);
    setAdminProfile({ id: data?.id, username: data?.username, role: data?.role });
    setTokenState(nextToken);
    setAdminState({ id: data?.id, username: data?.username, role: data?.role });
    return data;
  }, []);

  const logout = useCallback(() => {
    clearToken();
    clearAdminProfile();
    setTokenState('');
    setAdminState(null);
  }, []);

  const value = useMemo(
    () => ({
      token,
      admin,
      isAuthed: Boolean(token),
      login,
      logout,
    }),
    [token, admin, login, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}

